import React from 'react'

const Container = ({children, className}) => {
    return <div className={`max-w-container px-6 lg:px-12 w-full mx-auto ${className || ''}`}>{children}</div>
}

export default Container
